// extracted by mini-css-extract-plugin
export default {"wrapper":"EditHolidayMembersForm_wrapper__PsXuQ","membersWrapper":"EditHolidayMembersForm_membersWrapper__SDqmR","submitWrapper":"EditHolidayMembersForm_submitWrapper__7lisV"};